<template>
  <nav class="navbar" :class="{ responsive: isResponsive }">
    <div class="navbar-container">
      <button
        class="icon"
        @click="toggleMenu"
        aria-label="Toggle navigation menu"
        :aria-expanded="isResponsive"
      >
        <i class="fa fa-bars"></i>
      </button>
      <router-link to="/" class="navbar-item">Home</router-link>
      <router-link
        v-show="isResponsive || !isMobile"
        to="/projects"
        class="navbar-item"
      >
        Projects
      </router-link>
      <router-link
        v-show="isResponsive || !isMobile"
        to="/blog"
        class="navbar-item"
      >
        Blog
      </router-link>
      <router-link
        v-show="isResponsive || !isMobile"
        to="/resume"
        class="navbar-item"
      >
        Resume
      </router-link>
    </div>
  </nav>
</template>

<script>
import { mobileDetectionMixin } from '@/mixins/mobileDetection';

export default {
  name: "NavBar",
  mixins: [mobileDetectionMixin],
  data() {
    return {
      isResponsive: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isResponsive = !this.isResponsive;
    },
  },
};
</script>

<style scoped>
.navbar {
  width: 100%;
  padding: 1rem 2rem;
  background-color: var(--surface-bg);
  box-shadow: var(--shadow-elevation);
  color: var(--text-primary);
}

.navbar-container {
  display: flex;
  justify-content: center;
  gap: 2rem;
  align-items: center;
}

.navbar-item {
  font-size: 1rem;
  font-weight: 500;
  color: var(--text-primary);
  text-decoration: none;
  padding: 0.4rem 0.6rem;
  position: relative;
  transition: color 0.2s ease;
}

.navbar-item::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 2px;
  background-color: var(--accent);
  transition: width 0.3s ease;
}

.navbar-item:hover::after,
.navbar-item.router-link-active::after {
  width: 100%;
}

.navbar-item.router-link-active {
  color: var(--accent);
  font-weight: 600;
}

.icon {
  display: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-primary);
  background: none;
  border: none;
  padding: 0;
}

@media (max-width: 768px) {
  .navbar-container {
    flex-direction: row;
    justify-content: space-between;
    position: relative;
  }

  .icon {
    display: block;
  }

  .navbar-item {
    display: none;
    width: 100%;
    padding: 0.8rem 0;
  }

  .navbar.responsive .navbar-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    overflow: hidden;
    animation: slideDown 0.3s ease forwards;
  }

  .navbar.responsive .navbar-item {
    display: block;
    text-align: left;
    padding-left: 0;
  }
}

/* slideDown animation is now in shared animations.css */
</style>
